export const GET_SOLUTION_BY_QUESTION_SLUG_API_HTTP_STATUS_CODES = [
  403, 404, 422, 500, 503, 504,
];

export const GET_WHITEBOARD_SOLUTION_BY_QUESTION_SLUG_API_HTTP_STATUS_CODES = [
  400, 403, 404, 422, 500, 503, 504,
];

export const CREATE_SOLUTION_API_HTTP_STATUS_CODES = [
  400, 403, 404, 422, 500, 503, 504,
];

export const GET_SOLUTION_BY_QUESTION_SLUG_ERROR_MESSAGE =
  "Error in getting solution, please try again.";

export const GET_WHITEBOARD_SOLUTION_BY_QUESTION_SLUG_ERROR_MESSAGE =
  "Error in getting whiteboard solution, please try again.";

export const CREATE_SOLUTION_ERROR_MESSAGE =
  "Error in adding solution, please try again.";
